
@switch (columnId) {
  @case (DisputeOrderBy.CaseNumber) {
    <lib-text-table-column>
      {{ element.caseNumber }}
    </lib-text-table-column>
  }
  @case (DisputeOrderBy.Id) {
    <lib-text-table-column>
      {{ element.token }}
    </lib-text-table-column>
  }
  @case (DisputeOrderBy.RaiseDateUtc) {
    <lib-date-time-label [dateUtc]="element.raiseDateUtc"></lib-date-time-label>
    <lib-table-column-sort [key]="sortingKeyForRaiseDate"></lib-table-column-sort>
  }
  @case ('dueDateUtc') {
    <lib-date-time-label [dateUtc]="element.dueDateUtc"></lib-date-time-label>
    <lib-table-column-sort [key]="sortingKeyForDueDate"></lib-table-column-sort>
  }
  @case (DisputeOrderBy.CaseReason) {
    <lib-text-table-column>
      {{ element.reasonCodeDescription }}
    </lib-text-table-column>
  }
  @case ('amount') {
    <lib-text-table-column>
      {{ element.disputeAmount | vituCurrencyUsd }}
    </lib-text-table-column>
    <lib-table-column-sort [key]="element.disputeAmount ?? 0"></lib-table-column-sort>
  }
  @case ('statusDescription') {
    <lib-text-table-column>
      {{ element.statusDescription }}
    </lib-text-table-column>
  }
  @case ('statusDateUtc') {
    <lib-date-time-label [dateUtc]="element.statusDateUtc"></lib-date-time-label>
    <lib-table-column-sort [key]="sortingKeyForStatusDate"></lib-table-column-sort>
  }
  @case ('disputeOutcome') {
    <lib-text-table-column>
      {{ element.disputeOutcome }}
    </lib-text-table-column>
  }
  @case ('mid') {
    <lib-text-table-column>
      {{ element.mid }}
    </lib-text-table-column>
  }
  @case ('processor') {
    <lib-text-table-column>
      {{ element.processor }}
    </lib-text-table-column>
  }
  @case ('disputeType') {
    <lib-text-table-column>
      {{ element.disputeType }}
    </lib-text-table-column>
  }
  @case ('paymentToken') {
    <lib-text-table-column>
      {{ element.paymentToken }}
    </lib-text-table-column>
  }
  @case ('publicTransactionId') {
    <lib-text-table-column>
      {{ element.publicTransactionId }}
    </lib-text-table-column>
  }
  @default {
  }
}
